import React from 'react';
import { LightBulbIcon, XMarkIcon } from '@heroicons/react/24/outline';

interface WizardPromptBannerProps {
  onStartWizard: () => void;
  onDismiss: () => void;
}

const WizardPromptBanner: React.FC<WizardPromptBannerProps> = ({
  onStartWizard,
  onDismiss
}) => {
  return (
    <div className="wizard-prompt-banner">
      <div className="wizard-prompt-banner-content">
        <div className="wizard-prompt-banner-icon">
          <LightBulbIcon className="w-6 h-6" />
        </div>
        <div className="wizard-prompt-banner-text">
          <span className="wizard-prompt-banner-title">
            Not sure which stocks to pick?
          </span>
          <span className="wizard-prompt-banner-subtitle">
            Our quick 3-question wizard will filter 1000+ stocks to match your goals
          </span>
        </div>
        <div className="wizard-prompt-banner-actions">
          <button
            className="wizard-prompt-banner-cta"
            onClick={onStartWizard}
          >
            Start Wizard
          </button>
          <button
            className="wizard-prompt-banner-dismiss"
            onClick={onDismiss}
            aria-label="Dismiss banner"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default WizardPromptBanner;
